<template>
    <el-dialog
        :visible.sync="visible"
        :title="$t('Course.Coach.change_time')"
        left>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :status-icon="true"
            label-position="right"
            label-width="130px"
            label-suffix=":">
            <el-form-item prop="name" :label="$t('Course.name')">
                {{ form.lessonName }}
            </el-form-item>
            <el-form-item prop="time" :label="$t('Course.time')">
                {{ form.lessonTime }}
            </el-form-item>
            <el-form-item prop="storeId" :label="$t('Lesson.store')">
                <el-select
                    v-on:change="selectPlace"
                    class="pr-2"
                    v-model="form.storeId"
                    :placeholder="$t('Common.store_placeholder')">
                    <el-option
                        v-for="item in select.stores"
                        :key="item.id"
                        :label="item.name"
                        :value="Number(item.id)">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="placeId" :label="$t('Lesson.place')">
                <el-select
                    class="pr-2"
                    v-model="form.placeId"
                    :placeholder="$t('Common.place_placeholder')">
                    <el-option
                        v-for="item in select.places"
                        :key="item.id"
                        :label="item.name"
                        :value="Number(item.id)">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="coachId" :label="$t('Common.coach')">
                <el-select
                    class="pr-2"
                    v-model="form.coachId"
                    :placeholder="$t('Common.choose_coach')">
                    <input
                        class="croup-coach"
                        type="text"
                        v-model="searchText" >
                    <el-option
                        v-for="item in filterList"
                        :key="item.id"
                        :label="item.nickname"
                        :value="item.id"
                        :disabled="!item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="limit" :label="$t('Lesson.count')">
                <el-radio v-model="form.limit" label="0">
                    {{ $t('Lesson.limi') }}
                </el-radio>
                <el-radio v-model="form.limit" label="1">
                    <el-input
                        type="number"
                        v-model="form.totalAmt"
                        :placeholder="$t('Lesson.appoint_count')">
                    </el-input>
                </el-radio>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="confirm" type="primary">
                {{ $t('Common.submit') }}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import { Dialog, Radio } from 'element-ui';
import filterRole from '@/mixins/filterRole.js';

export default {
    name: 'editlessons',
    components: {
        ElDialog: Dialog,
        ElRadio: Radio,
    },
    data() {
        return {
            visible: false,
            id: null,
            form: {},
            rules: {
                storeId: { type: 'number', required: true },
                coachId: { type: 'number', required: true },
                placeId: { type: 'number', required: true },
                limit: { type: 'string', required: true },
            },
            select: {
                stores: [],
                places: [],
                coachs: [],
            },
            searchText: null,
        };
    },
    mixins: [filterRole],
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
        'form.limit'(val) {
            if (Number(val) === 0) this.form.totalAmt = null;
        },
    },
    computed: {
        filterList() {
            if (!this.searchText) return this.select.coachs;
            const arr = this.select.coachs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: null, nickname: this.$t('Common.data_not_found')}];
        },
    },
    methods: {
        resetForm() {
            this.$refs.form.resetFields();
        },
        async open(id) {
            // 团课id
            this.id = id;
            await this.fetchData();
            this.fetchStore();
            this.fetchCoach();
            this.visible = true;
        },
        // 获取团课详情
        fetchInfo(id) {
            API.get(`lesson/team/${id}`).then(res => {
                // 教练筛选
                const coachs = [];
                this.select.coachs.forEach(el => {
                    res.coachIds.forEach(item => {
                        if (item === el.id) coachs.push(el);
                    });
                });
                this.select.coachs = coachs;
                // 门店筛选
                const stores = [];
                this.select.stores.forEach(el => {
                    res.storeIds.forEach(item => {
                        if (item === el.id) stores.push(el);
                    });
                });
                this.select.stores = stores;
            });
        },
        // 获取课时数据
        fetchData() {
            API.get(`lesson/team/schedule/${this.id}/info`).then(res => {
                // 限制
                const limit = res.totalAmt ? '1' : '0';
                res.limit = res.totalAmt ? '1' : '0';
                res.totalAmt = res.totalAmt || null;
                this.form = res;
                this.selectPlace();
                this.fetchInfo(res.lessonId);
            });
        },
        confirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return false;
                const form = Object.assign({}, this.form);
                delete form.limit;
                delete form.id;
                delete form.lessonName;
                delete form.lessonTime;
                API.put(`lesson/team/schedule/${this.id}`, form).then(() => {
                    $ele.$message.success(this.$t('Lesson.success'));
                    this.$emit('fetchGroup');
                    this.visible = false;
                });
            });
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.select.stores = res;
            });
        },
        selectPlace() {
            API.get(`store/${this.form.storeId}/place/list`).then(res => {
                this.select.places = res;
            });
        },
        async fetchCoach() {
            this.select.coachs = await this.filterRole(10);
        },
    },
};
</script>

<style lang="scss">
.el-dialog {
    width: 430px;
    margin: 0 !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.el-dialog--center .el-dialog__body {
    padding: 25px 25px 0;
}
</style>
